var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSponsorInActive(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icons",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11288",
    "data-name": "Path 11288",
    d: "M17.027,38.182a.571.571,0,0,1-.56-.692l.963-4.212-3.34-3.069a.594.594,0,0,1,.387-1l4.4-.288,1.731-4.194a.577.577,0,0,1,1.067,0l1.731,4.194,4.4.288a.574.574,0,0,1,.352,1l-3.34,3.069.969,4.194a.571.571,0,0,1-.842.617l-3.831-2.14-3.825,2.14A.577.577,0,0,1,17.027,38.182Zm-1.154-7.91,2.59,2.383a.577.577,0,0,1,.173.577l-.756,3.254,2.977-1.662a.577.577,0,0,1,.577,0l2.977,1.662-.756-3.254a.577.577,0,0,1,.173-.577l2.59-2.383-3.41-.219a.577.577,0,0,1-.5-.352l-1.379-3.237-1.356,3.254a.577.577,0,0,1-.5.352Z",
    transform: "translate(-5.892 -10.31)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11289",
    "data-name": "Path 11289",
    d: "M40.305,33.61a.542.542,0,0,1-.277-.075L36.907,31.8l-1.621.906-.577-1.01,1.915-1.05a.577.577,0,0,1,.577,0l2.262,1.263-.577-2.469a.577.577,0,0,1,.173-.577l1.973-1.806-2.59-.167a.577.577,0,0,1-.5-.358l-1.033-2.469L35.88,26.537a.577.577,0,0,1-.5.358l-1.569.1-.075-1.154,1.212-.081,1.431-3.415a.577.577,0,0,1,1.062,0l1.431,3.415,3.577.231a.577.577,0,0,1,.352,1L40.08,29.5l.79,3.4a.608.608,0,0,1-.565.71Z",
    transform: "translate(-14.275 -9.304)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11290",
    "data-name": "Path 11290",
    d: "M4.913,33.61a.571.571,0,0,1-.565-.692l.79-3.421-2.717-2.5a.577.577,0,0,1,.352-1l3.577-.231L7.78,22.343a.577.577,0,0,1,1.062,0l1.431,3.415,1.212.081-.075,1.154-1.569-.1a.577.577,0,0,1-.5-.358L8.311,24.068,7.29,26.531a.577.577,0,0,1-.5.358l-2.59.167,1.962,1.806a.577.577,0,0,1,.173.577l-.577,2.469L8.028,30.65a.577.577,0,0,1,.577,0l1.9,1.062-.577,1.01L8.311,31.8,5.19,33.535A.542.542,0,0,1,4.913,33.61Z",
    transform: "translate(-0.944 -9.304)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11291",
    "data-name": "Path 11291",
    d: "M27.638,22.137H26.484v-3.3c-.04-.41-1.835-1.523-3.623-1.523s-3.583,1.113-3.617,1.529v3.294H18.09v-3.3c0-1.477,2.885-2.677,4.771-2.677s4.777,1.2,4.777,2.677Z",
    transform: "translate(-7.653 -6.837)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11292",
    "data-name": "Path 11292",
    d: "M24.177,10.244A2.818,2.818,0,0,1,21.2,7.723V6.211A2.818,2.818,0,0,1,24.177,3.69a2.818,2.818,0,0,1,2.977,2.521V7.723A2.814,2.814,0,0,1,24.177,10.244Zm0-5.4c-.952,0-1.823.652-1.823,1.367V7.723c0,.715.871,1.367,1.823,1.367S26,8.438,26,7.723V6.211c0-.715-.877-1.367-1.823-1.367Z",
    transform: "translate(-8.969 -1.561)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3774",
    "data-name": "Rectangle 3774",
    width: 30,
    height: 30,
    fill: "none"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSponsorInActive);
export default __webpack_public_path__ + "static/media/sponsor_inActive.aec09247d336cef9ae87d327b5737c37.svg";
export { ForwardRef as ReactComponent };